module.exports = __webpack_public_path__ + "static/media/map.5fb32a7f.jpg";